import styled from 'styled-components'
import { Form } from 'lib/ui'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  max-width: ${props => props.theme.maxWidth};
  margin: 0 auto;
  padding: 30px 30px 80px;
  ${bp('sm')`
    padding: 20px 0 60px;
  `}

  h1 {
    font: ${font('alt', 'medium', '27px')};
    text-align: center;
    margin: 20px 20px 40px;
  }

  h2 {
    font: ${font('alt', 'medium', '19px')};
    margin: 15px 0 30px;
  }
`

export const MainFormContainer = styled.div`
  form {
    margin: 0 auto;
  }

  ${Form.Actions.Styled} {
    margin: 30px 0 0;
    padding: 30px 0 0;
    border-top: 1px solid ${props => props.theme.form.passiveColor};
    ${bp('sm')`
      padding-bottom: 60px;
    `}

    button {
      font-size: 17px;
      ${bp('sm')`
        width: 100%;
      `}
    }
  }
`

export const CheckoutLayout = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  h2 {
    display: flex;
    align-items: center;

    > div {
      margin: 0 0 0 10px;
    }
  }
`

export const CheckoutMain = styled.div`
  width: calc(100% - 330px);
  max-width: 690px;
  margin: 0;
  padding: 0 30px 0 0;
  box-sizing: border-box;
  ${bp('sm')`
    width: 100%;
    padding: 0 20px 20px;
  `}
`

export const CheckoutAside = styled.div`
  position: sticky;
  top: 20px;
  width: 330px;
  box-sizing: border-box;
  ${bp('sm')`
    width: 100%;
  `}

  > div {
    background: ${props => props.theme.palette.general.soft};
    border: 1px solid ${props => props.theme.palette.general.greyLight};
  }
`
